<template>
    <transition name="component-fade" mode="out-in" v-on:before-enter="onBeforeEnter" v-on:enter="onEnter">
        <router-view v-bind:lead="lead" v-bind:appState="appState" v-on:complete="onStepComplete" v-on:invalidInput="logInvalidInputEvent"></router-view>
    </transition>
</template>

<script>

import { steps, stepValues } from "./steps.js";
import { typeValues } from "./types.js";

export default {
    data: function() {
        return {
            queriedLeadInfo: false,
            queriedHomeInfo: false,
            homeFound: false
        }
    },
    props: {
        appState: Object,
        lead: Object,
        eventBus: Object
    },
    mounted: function() {
        this.eventBus.$on("goToPreviousStep", this.goToPreviousStep);
        this.eventBus.$on("goToStep", this.goToStep);
    },
    methods: {
        onBeforeEnter: function() {
            this.$emit("preStepTransition")
        },
        onEnter: function() {
            this.$emit("postStepTransition")
        },
        onStepComplete: function(name, value) {
            this.utils.log("onStepComplete: " + this.currentStep);
			this.utils.log(value);
			this.utils.log(this.lead);

            this.$emit("stepComplete");
            this.$gtag.event(value ? value.toString() : null, {"event_category": this.currentStep, "event_label": this.lead.id});
			this.goToNextStep(value);
        },
        currentStepIndex: function() {
            return steps[this.currentType].indexOf(this.currentStep);
        },
        goToPreviousStep: function() {
            this.$gtag.event("back", {"event_category": this.currentStep, "event_label": this.lead.id});
            this.utils.log("goToPreviousStep from " + this.currentStep);

            if (this.currentStep != steps[this.currentType][0]) {

                // do some clean up for certain steps
                switch (this.currentStep) {
                    case stepValues.VehicleMake:
                        this.lead.autoInsurance.vehicles[this.lead.autoInsurance.vehicles.length - 1].year = null;
                        break;
                    case stepValues.VehicleModel:
                        this.lead.autoInsurance.vehicles[this.lead.autoInsurance.vehicles.length - 1].make = null;
                        break;
                    case stepValues.VehicleTrimAndVehicleOwnershipType:
                        this.lead.autoInsurance.vehicles[this.lead.autoInsurance.vehicles.length - 1].model = null;
                        break;
                }

                this.$router.go(-1);
            }
        },
        nextStep: function() {
            var currentStepIndex = this.currentStepIndex();

            if (currentStepIndex >= 0 && currentStepIndex + 1 < steps[this.currentType].length) {
                return steps[this.currentType][currentStepIndex + 1];
            }

            return this.$route.path.split("/")[2];
        },
        goToNextStep: function(val) {
            var nextStep = "";

            if (this.currentType === typeValues.Auto) {

                if (!this.lead.insuranceType) {
                    this.lead.insuranceType = "AutoInsurance";
                }

                switch (this.currentStep) {
                    case stepValues.AutoInsuranceLength:
                        if (val === 0) {
                            nextStep = stepValues.NumberOfDrivers;
                        }
                        else {
                            nextStep = this.nextStep();
                        }
                        break;
                    case stepValues.VehicleYear:
                        if (val && !this.appState.makeModelTrimsByYear[val]) {
                            this.loadMakeModelTrims(val);
                        }

                        nextStep = this.nextStep();
                        break;
                    case stepValues.AddAnotherVehicle:
                        if (val) {
                            this.lead.autoInsurance.vehicles.push(this.utils.getNewVehicle());
                            nextStep = stepValues.VehicleYear;
                        }
                        else {
                            nextStep = stepValues.AutoInsuranceLength;

                            // clean up any empty vehicles
                            if (this.lead.autoInsurance.vehicles) {
                                var vehicle = this.lead.autoInsurance.vehicles[this.lead.autoInsurance.vehicles.length - 1];

                                if (!vehicle.year || !vehicle.make || !vehicle.model || !vehicle.trim) {
                                    this.lead.autoInsurance.vehicles.pop();
                                }
                            }
                        }
                        break;
                    case stepValues.DateOfBirthNameAddressCityZipCodeEmailPhoneNumber:
                        this.$emit("complete");
                        nextStep = null;
                        break;
                    default:
                        nextStep = this.nextStep();
                        break;
                }
            } else if (this.currentType === typeValues.Home) {

                if (!this.lead.insuranceType) {
                    this.lead.insuranceType = "HomeInsurance";
                }

                switch (this.currentStep) {
                    case stepValues.OwnHome:
                        if (!val) {
                            this.appState.messageTitle = "We're sorry";
                            this.appState.message = "We don't offer renter's insurance at this time.";
                            nextStep = "/" + typeValues.Post + "/" + stepValues.Message;
                        }
                        else {
                            nextStep = this.nextStep();
                        }
                        break;
                    case stepValues.YearHomeBought:
                        if (this.queriedHomeInfo) {
                            if (!this.homeFound) {
                                nextStep = stepValues.Name;
                            }
                            else {
                                nextStep = this.nextStep();
                            }
                        }
                        else {
                            this.queryHomeInfo();
                            nextStep = null;
                        }
                        break;
                    case stepValues.CurrentHomeInsurer:
                        if (!val) {
                            nextStep = stepValues.Name;
                        }
                        else {
                            nextStep = this.nextStep();
                        }
                        break;
                    case stepValues.PhoneNumber:
                        this.$emit("complete");
                        nextStep = null;
                        break;
                    default:
                        nextStep = this.nextStep();
                        break;
                }
            } else {
                if (this.lead.insuranceType == "AutoInsurance") {
                    nextStep = "/" + typeValues.Auto;
                } else if (this.lead.insuranceType == "HomeInsurance") {
                    nextStep = "/" + typeValues.Home;
                }
            }

            if (nextStep) {
                this.$emit("loading", false);
                this.utils.log("goToNextStep from " + this.currentStep + " to " + nextStep);
                this.$router.push(nextStep);
            }
        },
        goToStep: function(step) {
            this.utils.log("goToStep");
            this.utils.log(step);
            var nextStep = step;

            this.$router.push(nextStep);
        },
        logInvalidInputEvent: function(step, value) {
            this.utils.log("logInvalidInputEvent: " + step + ", " + value);
            this.$gtag.event("invalid: '" + value.toString() + "'", {"event_category": step, "event_label": this.lead.id});
        },
        loadMakeModelTrims: function(year) {
            this.$emit("loading", true);

            var yearMakeModelTrimUrl = this.appConfig.yearMakeModelTrimsUrlBase + year + this.appConfig.yearMakeModelTrimsFileExtension;
            this.utils.log("loading make model trims for year " + year);
            this.utils.log(yearMakeModelTrimUrl);

            var vm = this;

            this.axios.get(yearMakeModelTrimUrl)
                .then(function (response) {
                    vm.utils.log("loaded make model trims for year " + year);
                    vm.utils.log(response);
                    vm.appState.makeModelTrimsByYear[year] = response.data;
                })
                .catch(function (error) {
                    var errorMessage = "error loading make model trims";

                    if (error.response) {
                        errorMessage += " - status " + error.response.status;
                    }
                    else if (error.request) {
                        errorMessage += " - no response (" + error.request.status + ")";
                    }
                    else {
                        errorMessage += " - error " + error.message;
                    }

                    vm.utils.log(errorMessage);
                    vm.utils.log(error);

                    try {
                        vm.$gtag.event("error loading make model trims", {"event_category": "App", "event_label": vm.lead.id});
                    } catch (e) {
                        vm.utils.log(e);
                    }

                    vm.appState.makeModelTrimsByYear[year] = {};
                })
        },
        queryLeadInfo: function() {
            this.$emit("loading", true);
            var query = this.getQuery();
            this.utils.log("quering lead info");
            this.utils.log(query);

            var vm = this;

            this.axios.post("/Api/Widget/QueryLeadInfo", query)
                .then(function (response) {
                    vm.utils.log("queried lead");
                    vm.utils.log(response);
                    vm.handleQueryResponse(response);
                })
                .catch(function (error) {
                    var errorMessage = "error querying lead";

                    if (error.response) {
                        errorMessage += " - status " + error.response.status;
                    }
                    else if (error.request) {
                        errorMessage += " - no response (" + error.request.status + ")";
                    }
                    else {
                        errorMessage += " - error " + error.message;
                    }

                    vm.utils.log(errorMessage);
                    vm.utils.log(error);

                    try {
                        vm.$gtag.event("error querying lead", {"event_category": "App", "event_label": vm.lead.id});
                    } catch (e) {
                        vm.utils.log(e);
                    }

                    vm.handleQueryResponse(error);
                });
        },
        queryHomeInfo: function() {
            this.$emit("loading", true);
            var query = this.getHomeQuery();
            this.utils.log("quering home info");
            this.utils.log(query);

            var vm = this;

            this.axios.post("/Api/Widget/QueryHomeInfo", query)
                .then(function (response) {
                    vm.utils.log("queried home info");
                    vm.utils.log(response);
                    vm.handleQueryHomeResponse(response);
                })
                .catch(function (error) {
                    var errorMessage = "error querying home";

                    if (error.response) {
                        errorMessage += " - status " + error.response.status;
                    }
                    else if (error.request) {
                        errorMessage += " - no response (" + error.request.status + ")";
                    }
                    else {
                        errorMessage += " - error " + error.message;
                    }

                    vm.utils.log(errorMessage);
                    vm.utils.log(error);

                    try {
                        vm.$gtag.event("error querying home", {"event_category": "App", "event_label": vm.lead.id});
                    } catch (e) {
                        vm.utils.log(e);
                    }

                    vm.handleQueryHomeResponse(error);
                });
        },
        getQuery: function() {
            return {
                Id: this.lead.id,
				ApiKey: this.appConfig.apiKey,
				DateOfBirth: this.getDateOfBirth(),
				StreetAddress: this.lead.streetAddress,
				City: this.lead.city,
                State: this.lead.state,
				ZipCode: this.lead.zipCode,
				FirstName: this.lead.firstName,
				LastName: this.lead.lastName,
				Email: this.lead.email
			}
        },
        getHomeQuery: function() {
            return {
                Id: this.lead.id,
                ApiKey: this.appConfig.apiKey,
                Address: this.lead.streetAddress,
                City: this.lead.city,
                State: this.lead.state
            }
        },
        getDateOfBirth: function() {
            return this.lead.dateOfBirthYear + "-" + this.lead.dateOfBirthMonth + "-" + this.lead.dateOfBirthDay;
        },
        handleQueryResponse: function(response) {
            if (response.data) {
                var vehicles = response.data.Vehicles;
                if (vehicles) {
                    vehicles.forEach((vehicle) => {
                        var leadVehicle = {
                            "year": vehicle.Year,
                            "make": vehicle.Make,
                            "model": vehicle.Model,
                            "trim": vehicle.Trim,
                            "vin": vehicle.Vin,
                            "primaryUse": vehicle.PrimaryUseType,
                            "annualMileage": vehicle.AnnualMileage,
                            "daysDrivenPerWeek": vehicle.DaysDrivenPerWeek,
                            "selected": true
                        };
                        this.lead.pendingVehicles.push(leadVehicle);
                    });

                    this.utils.log("added pendingVehicles")
                    this.utils.log(this.lead.pendingVehicles);
                }
            }

            this.queriedLeadInfo = true;
            this.goToNextStep();
        },
        handleQueryHomeResponse: function(response) {
            if (response.data && response.data.HomeFound === true) {
                this.utils.log("home found")
                this.homeFound = true;
            }
            else {
                this.utils.log("home not found");
                this.homeFound = false;
            }

            this.queriedHomeInfo = true;
            this.goToNextStep();
        },
        tryToSetVehicleTrim: function(pendingVehicle) {
            this.utils.log("tryToSetVehicleTrim");

            // look up trims
            if (!pendingVehicle.trim) {
                if (typeof window.AvengeDigitalWidgetYearMakeModelTrims !== "undefined") {

                    try {
                        var year = pendingVehicle.year;
                        var make = this.utils.toTitleCase(pendingVehicle.make);
                        var model = this.utils.toTitleCase(pendingVehicle.model);
                        var trims = window.AvengeDigitalWidgetYearMakeModelTrims;

                        this.utils.log("looking up " + year + " " + make + " " + model);

                        if (trims[year] && trims[year][make] && trims[year][make][model] && trims[year][make][model].length > 0) {
                            pendingVehicle.trim = trims[year][make][model][0];
                            this.utils.log("set trim to " + pendingVehicle.trim);
                        }
                        else {
                            this.utils.log("unable to set vehicle trim");
                            this.$gtag.event("unable to set vehicle trim", {"event_category": "App", "event_label": this.lead.id, "value": year + " " + make + " " + model});
                        }
                    }
                    catch (e) {
                        this.utils.log("error trying to set vehicle trim");
                        this.utils.log(e);
                        this.$gtag.event("unable to set vehicle trim", {"event_category": "App", "event_label": this.lead.id, "value": e.message});
                    }
                }
            }
        }
    },
    computed: {
        currentType: function () {
            return this.$route.path.split("/")[1];
        },
        currentStep: function () {
            return this.$route.path.split("/")[2];
        }
    }
}

</script>

<style scoped>
    .component-fade-enter-active, .component-fade-leave-active {
      transition: opacity .2s ease;
    }

    .component-fade-enter, .component-fade-leave-to
    /* .component-fade-leave-active below version 2.1.8 */ {
      opacity: 0;
    }
</style>
